import { Phone } from "lucide-react";
import { scrollToForm } from "@/App";

const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-navy-deep border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-[52px] md:h-[76px] flex items-center justify-between">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2.5 md:gap-3">
          <img
            src="/images/c2h-logo.webp"
            alt="C2H Energy"
            className="h-7 w-7 md:h-10 md:w-10 object-contain"
            loading="eager"
          />
          <span className="leading-tight">
            <span className="block font-bold text-white text-xs md:text-sm tracking-[0.18em]">
              C2H ENERGY
            </span>
            <span className="hidden md:block text-[10px] uppercase tracking-[0.25em] text-[#9fb3d1] mt-0.5">
              Melbourne, Victoria, Australia
            </span>
          </span>
        </a>
        <div className="flex items-center gap-3 md:gap-5">
          <a
            href="tel:+61494686355"
            data-testid="header-phone-icon-button"
            aria-label="Call C2H Energy"
            className="md:hidden flex items-center justify-center w-9 h-9 rounded-full border border-white/20"
          >
            <Phone className="w-4 h-4 text-glight" />
          </a>
          <a
            href="tel:+61494686355"
            data-testid="header-phone-link"
            className="hidden md:flex items-center gap-2 text-base font-semibold text-white/90 hover:text-white transition-colors duration-200"
          >
            <Phone className="w-4 h-4 text-glight" />
            0494 686 355
          </a>
          <button
            onClick={scrollToForm}
            data-testid="header-cta-button"
            className="hidden md:inline-flex bg-amber text-navy-deep text-sm font-bold px-5 py-2.5 rounded-lg hover:-translate-y-0.5 transition-transform duration-200 cta-pulse"
          >
            See My Price
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
